export const tones = {
    neutral: 'neutral',
    outline: 'outline',
    blue: 'blue',
    green: 'green',
    emerald: 'emerald',
    amber: 'amber',
    orange: 'orange',
    red: 'red',
    purple: 'purple',
    violet: 'violet',
}

export const toneIntensities = {
    soft: 'soft',
    strong: 'strong',
    surface: 'surface',
}

const softToneClassNames = {
    [tones.neutral]: 'bg-gray-100 text-gray-500',
    [tones.outline]: 'border border-gray-300 text-gray-500',
    [tones.blue]: 'bg-blue-50 text-blue-600',
    [tones.green]: 'bg-green-50 text-green-600',
    [tones.emerald]: 'bg-emerald-50 text-emerald-600',
    [tones.amber]: 'bg-amber-50 text-amber-600',
    [tones.orange]: 'bg-orange-50 text-orange-600',
    [tones.red]: 'bg-red-50 text-red-600',
    [tones.purple]: 'bg-purple-50 text-purple-600',
    [tones.violet]: 'bg-violet-50 text-violet-600',
}

const strongToneClassNames = {
    [tones.neutral]: 'bg-gray-100 text-gray-700',
    [tones.outline]: 'border border-gray-300 text-gray-600',
    [tones.blue]: 'bg-blue-100 text-blue-800',
    [tones.green]: 'bg-emerald-100 text-emerald-800',
    [tones.emerald]: 'bg-emerald-100 text-emerald-800',
    [tones.amber]: 'bg-amber-100 text-amber-800',
    [tones.orange]: 'bg-orange-100 text-orange-800',
    [tones.red]: 'bg-red-100 text-red-800',
    [tones.purple]: 'bg-purple-100 text-purple-800',
    [tones.violet]: 'bg-violet-100 text-violet-800',
}

const surfaceToneClassNames = {
    [tones.neutral]: 'border border-gray-200 bg-gray-50 text-gray-700',
    [tones.outline]: 'border border-gray-300 bg-white text-gray-700',
    [tones.blue]: 'border border-blue-200 bg-blue-50 text-blue-900',
    [tones.green]: 'border border-green-200 bg-green-50 text-green-900',
    [tones.emerald]: 'border border-emerald-200 bg-emerald-50 text-emerald-900',
    [tones.amber]: 'border border-amber-200 bg-amber-50 text-amber-900',
    [tones.orange]: 'border border-orange-200 bg-orange-50 text-orange-900',
    [tones.red]: 'border border-red-200 bg-red-50 text-red-900',
    [tones.purple]: 'border border-purple-200 bg-purple-50 text-purple-900',
    [tones.violet]: 'border border-violet-200 bg-violet-50 text-violet-900',
}

const classNamesByIntensity = {
    [toneIntensities.soft]: softToneClassNames,
    [toneIntensities.strong]: strongToneClassNames,
    [toneIntensities.surface]: surfaceToneClassNames,
}

export const getToneClassName = (tone, intensity = toneIntensities.soft) => {

    const toneClassNames = classNamesByIntensity[intensity] || softToneClassNames;

    return toneClassNames[tone] || toneClassNames[tones.neutral];
}
